import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-351b846b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "mt-5 mt-lg-0"
}
const _hoisted_2 = {
  key: 1,
  class: "row"
}
const _hoisted_3 = {
  key: 0,
  class: "text-center fw-bold mt-5"
}
const _hoisted_4 = {
  key: 0,
  class: "bg-white shadow room-container p-lg-4 p-2 position-relative"
}
const _hoisted_5 = { class: "header border-bottom mb-3" }
const _hoisted_6 = { class: "header-height" }
const _hoisted_7 = { class: "d-flex align-items-center mt-lg-4 mt-2 mb-3" }
const _hoisted_8 = { class: "fw-bold fs-7 d-flex" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 1,
  class: "d-flex justify-content-center"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spinner-border" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 3,
  class: "d-flex justify-content-center mt-5"
}

import Heading from '@/views/user/groups/components/Heading.vue'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import Submenu from '@/components/submenu/index.vue'
import { translate } from '@/languages/i18n'
import TargetTag from '@/components/target-tag/index.vue'
import CreateTalkRoomModal from '@/views/user/groups/components/CreateTalkRoomModal.vue'
import EditTalkRoomModal from '@/views/user/groups/components/EditTalkRoomModal.vue'
import DeleteTalkRoom from '@/views/user/groups/components/DeleteTalkRoom.vue'
import Button from '@/components/button/index.vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { GROUPS_STORE } from '@/store/constants'
import { onMounted, computed, ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()
const listTalkRooms = computed(() => store.getters[GROUPS_STORE.GETTERS.LIST_TALK_ROOMS_LOAD_MORE])
const loadingDetail = computed(() => store.getters[GROUPS_STORE.GETTERS.LOADING_DETAIL])
const talkRoomId = ref('')
const talkRoomName = ref('')
const lastGroup = ref<HTMLElement>()
const page = ref<number>(1)
const observer = ref()
// 2022/09/30 CW-Phuong Fix for UAT Phase2#4473: SO10 (Ph2-R20220930)
const paramGetTalkRooms = ref()

const menu = [
  {
    title: translate('editRoom'),
  },
  {
    title: translate('deleteRoom'),
  },
]
const loadingListTalkRoom = ref<boolean>(false)
const getListTalkRooms = async (page: number, change) => {
  if (!route?.params?.id) return
  loadingListTalkRoom.value = true
  try {
    // 2022/09/30 CW-Phuong Fix for UAT Phase2#4473: SO10 (Ph2-R20220930)
    paramGetTalkRooms.value = { change, id: route.params?.group_id, params: { ...(page && { page }), published: true } }
    await store.dispatch(GROUPS_STORE.ACTIONS.SET_LIST_TALK_ROOMS_LOAD_MORE, paramGetTalkRooms.value)
    setTimeout(() => {
      loadingListTalkRoom.value = false
    }, 1000)
  } catch (error) {
    console.log(error)
    loadingListTalkRoom.value = false
  }
}
onMounted(() => {
  observer.value = new IntersectionObserver((entries) => {
    if (entries[0].isIntersecting) {
      if (page.value === listTalkRooms.value.total_pages_talk) return
      if (listTalkRooms?.value?.listTalkRoomsLoadMore?.length < 10) return
      page.value++
      getListTalkRooms(page.value)
    }
  })

  if (lastGroup.value) {
    observer?.value?.observe(lastGroup.value)
  }
})
onMounted(() => {
  getListTalkRooms(page.value, true)
})

watch(
  () => lastGroup.value,
  () => {
    if (lastGroup.value) {
      observer?.value?.observe(lastGroup.value)
    }
  }
)
const ChangeDataModal = (id: string | number, name: string) => {
  talkRoomId.value = id
  talkRoomName.value = name
}

const TransitSO65 = (id: number | string) => {
  router.push(`${route.path}/${id}`)
}

const backToGroups = () => {
  const previousUrlArray = router.options.history.state.back?.split('/')
  if (previousUrlArray?.pop().split('?')[0] === 'groups') {
    router.go(-1)
  } else {
    router.push(`/${route.path.split('/')[1]}/communities/${route.params?.id}/groups`)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Heading),
    (!_unref(loadingDetail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(CreateTalkRoomModal)
        ]))
      : _createCommentVNode("", true),
    (!_unref(loadingDetail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_unref(listTalkRooms)?.listTalkRoomsLoadMore.length === 0 && !_unref(listTalkRooms)?.loadingTalkRooms)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(translate)('SO10noTalkRoom')), 1))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(listTalkRooms)?.listTalkRoomsLoadMore, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-lg-6 p-lg-3 py-2",
              key: item
            }, [
              (_unref(listTalkRooms)?.listTalkRoomsLoadMore.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_router_link, {
                          to: `${_unref(route).path}/${item?.id}`,
                          class: "text-header fw-bold text-black text-decoration-underline mb-2 d-block pe-5"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item?.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(UserAliasIcon, {
                          userType: item?.admin.user_type
                        }, null, 8, ["userType"]),
                        _createElementVNode("div", _hoisted_8, _toDisplayString(item?.admin?.display_name), 1)
                      ])
                    ]),
                    (item?.is_admin || item?.is_community_admin)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "sub-menu-container position-absolute",
                          onClick: ($event: any) => (ChangeDataModal(item?.id, item?.name))
                        }, [
                          _createVNode(Submenu, {
                            menu: menu,
                            dataBs: [
              ['modal', '#editRoom'],
              ['modal', '#deleteRoom'],
            ]
                          })
                        ], 8, _hoisted_9))
                      : _createCommentVNode("", true),
                    _createVNode(TargetTag, {
                      data: item?.information,
                      class: "information mb-3 cursor-pointer",
                      onClick: ($event: any) => (TransitSO65(item?.id))
                    }, null, 8, ["data", "onClick"])
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (_unref(listTalkRooms)?.loadingTalkRooms && !_unref(loadingDetail))
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(listTalkRooms)?.listTalkRoomsLoadMore?.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          ref: (_value, _refs) => {
            _refs['lastGroup'] = _value
            lastGroup.value = _value
          }
        }, null, 512))
      : _createCommentVNode("", true),
    (!_unref(loadingDetail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(Button, {
            title: _unref(translate)('backToGroup'),
            type: "secondary",
            onClick: backToGroups,
            size: "small",
            className: "fw-bold"
          }, null, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(EditTalkRoomModal, { talkRoomId: talkRoomId.value }, null, 8, ["talkRoomId"]),
    _createVNode(DeleteTalkRoom, {
      talkRoomId: talkRoomId.value,
      talkRoomName: talkRoomName.value,
      paramGetTalkRooms: paramGetTalkRooms.value
    }, null, 8, ["talkRoomId", "talkRoomName", "paramGetTalkRooms"])
  ], 64))
}
}

})